import styled from 'styled-components';

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px;
`;

export const FooterRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 30px;
    border-top: 1px solid #444;
    background-color: #222;
`;

export const ButtonBack = styled.div`
    border: 0px;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;

    &:before {
        transition: color .4s ease 0s;
        content: '\\F004D';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 25px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #fff;
    }
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:first-child) {
        margin-left: 5px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    height: 25px;
    min-height: 25px;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0 0 10px 5px;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    &:not(.disabled):hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &.disabled {
        cursor: default;
        opacity: .5;
    }

    &.special {
        width: 200px;
        min-width: 200px;
        height: 30px;
        min-height: 30px;
        margin: 0 10px 0 0;

        &:last-child {
            margin: 0;
        }
    }
`;

export const Error = styled.div`
    display: flex;
    width: 100%;
    border: 1px solid #f99;
    background-color: #400;
    color: #f99;
    font-size: 14px;
    text-align: 20px;
    padding: 10px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${p => p.align ?? 'flex-start'};
    justify-content: ${p => p.justify ?? 'flex-start'};
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    
    &:not(.noFlex) {
        flex: 1;
    }

    &.mr {
        margin-right: 15px;
    }
`;

export const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 0 50px 50px;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;

    &.username {
        position: relative;

        & input {
            padding: 0 0 0 17px;
        }

        &:before {
            content: "@";
            position: absolute;
            left: 0;
            bottom: 11px;
            font-size: 14px;
            width: 20px;
            height: 25px;
            color: #ccc;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
`;

export const Image = styled.div`
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    height: 100px;
    min-height: 100px;
    max-height: 100px;
    background-color: ${p => p.color || "#000"};
    color: ${p => p.fgColor ?? "#fff"};
    position: relative;
    margin: 0 20px 20px 0;
    font-size: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Label = styled.div`
    font-size: 14px;
    color: #999;
    margin-bottom: 5px;

    &.large {
        width: 150px;
        min-width: 150px;
    }

    &.row {
        margin-bottom: 10px;
        margin-right: 10px;
        width: 80px;
    }
`;

export const Value = styled.div`
    flex: 1;
    color: #888;
    font-size: 14px;
    height: 25px;
    min-height: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 5px 10px 0;
`;

export const Input = styled.input.attrs(p => ({
    type: "text"
}))`
    color: #fff;
    background-color: #111;
    font-size: 14px;
    height: 25px;
    min-height: 25px;
    margin: 0 5px 10px 0;
    border: 1px solid #999;
    box-sizing: border-box;
`;

export const TextArea = styled.textarea`
    color: #fff;
    background-color: #111;
    font-size: 14px;
    margin: 0 5px 10px 0;
    border: 1px solid #999;
    box-sizing: border-box;
`;

export const Select = styled.select`
    color: #fff;
    background-color: #111;
    font-size: 14px;
    height: 25px;
    min-height: 25px;
    margin: 0 5px 10px 0;
    border: 1px solid #999;
    box-sizing: border-box;
`;

export const Separator = styled.div`
    color: #888;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    margin: 20px 0;

    &:before,
    &:after {
        content: '';
        height: 1px;
        background-color: #999;
        flex: 1;
    }

    &:before {
        margin-right: 15px;
    }
    &:after {
        margin-left: 15px;
    }
`;

export const UserTabs = styled.div`
    width: 100%;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #999;
    margin-bottom: 20px;
`;

export const UserTab = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    cursor: pointer;
    height: 40px;
    margin-bottom: -1px;
    border: 1px solid transparent;
    border-bottom: 1px solid #999;
    border-top: 3px solid transparent;

    &.selected {
        border: 1px solid #999;
        border-bottom: 1px solid #333;
        border-top: 3px solid #999;
    }
`;

export const Colors = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
`;

export const Color = styled.div.attrs(p => ({
    style: {
        backgroundColor: p.color ?? '#fff',
    }
}))`
    width: 20px;
    height: 20px;
    border: 1px solid #999;
    margin: 0 5px 5px 0;
    border-radius: 10px;
    cursor: pointer;

    &.selected {
        border: 2px solid #fff;
    }
`;

export const Availabilities = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
    flex-wrap: wrap;
    margin: 0;
`;

export const NoAvailability = styled.div`
    width: 100%;
    font-size: 16px;
    color: #999;
    text-align: center;
    font-style: italic;
    margin-top: 10px;
`;

export const TableRow = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    cursor: pointer;

    &:nth-child(odd) {
        background-color: rgba(255,255,255,0.1);
    }
    &:nth-child(even) {
        background-color: rgba(255,255,255,0.2);
    }

    &:not(.selected):hover {
        background-color: rgba(255,255,255,0.3);
    }
    &.selected {
        background-color: rgba(255,255,255,0.4);
    }
`;

export const TableData = styled.div`
    padding: 10px 5px;
    color: #fff;
`;

export const LanguageItem = styled.div`
    height: 20px;
    width: 20px;
    margin-right: 5px;
    border-radius: 10px;
    background: url('/app/images/lang_${props => props.icon}.png') no-repeat 50% 50%;
    background-size: cover;
    overflow: hidden;
    box-sizing: border-box;
    border: 2px solid #999;
    cursor: pointer;

    &:last-child {
        margin-right: 0;
    }

    &.active {
        border: 2px solid #f92;
    }
`;